import React, { Component } from 'react';
import {  Toast  } from 'react-bootstrap';


class Mensajes extends Component {

    cerrar=()=>{
        const {ocultar} = this.props;
        ocultar();
    }

    render() {
        const {mensaje} = this.props;
        const {estado} = this.props;
        return (
            <Toast style={{ backgroundColor: "#a9d1f9", border: "1px solid black" }} onClose={this.cerrar} show={estado} delay={5000} autohide>
                    <Toast.Header style={{ backgroundColor: "black" }}>
                        <strong className="mr-auto">Respuesta</strong>
                    </Toast.Header>
                    <Toast.Body>
                        {mensaje}
                    </Toast.Body>
                </Toast>
            
        );
    }
}
export default (Mensajes);


// WEBPACK FOOTER //
// ./src/components/subcomponent/mensajes.jsx